import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import BankStatementAnalysis from "./BankStatementAnalysis";
import BSAOutputDetails from "./BSAOutputDetails";
import { useHistory, useLocation } from "react-router-dom";

const BankStatementAnalyzer: React.FC = () => {
  const dispatch = useDispatch();
  const { state, href }: any = useLocation();
  const history = useHistory();

  const [showBSAOutputDetailsFor, setShowBSAOutputDetailsFor] = useState("");
  const [bsaSelectedTab, setBSASelectedTab] = useState<
    "INPUT" | "OUTPUT" | undefined
  >(state?.isOpenBSAOutput ? "OUTPUT" : "INPUT");

  useEffect(() => {
    if(state?.isOpenBSAOutput) {
      history.replace(href, {});
    }
    dispatch(setScreenHeader({ screenTitle: "Bank Statement Analyzer" }));
  }, []);

  return (
    <div className="content-box btn-box" style={{ maxWidth: "900px" }}>
      {(showBSAOutputDetailsFor?.length ?? 0) > 0 ? (
        <BSAOutputDetails
          showBSAOutputDetailsFor={showBSAOutputDetailsFor}
          setShowBSAOutputDetailsFor={setShowBSAOutputDetailsFor}
          setBSASelectedTab={setBSASelectedTab}
        />
      ) : (
        <BankStatementAnalysis
          setShowBSAOutputDetailsFor={setShowBSAOutputDetailsFor}
          bsaSelectedTab={bsaSelectedTab}
        />
      )}
    </div>
  );
};

export default BankStatementAnalyzer;
